import useSWRMutation from "swr/mutation";
import { fetchSignedAssetDownloadUrl } from "~/lib/client/endilApiCalls";

export const useFetchSignedAssetUrl = ({
  postId,
  attachmentId,
  shouldFetch,
}: {
  postId: string | number;
  attachmentId: string | number;
  shouldFetch: boolean;
}) =>
  useSWRMutation(
    shouldFetch ? `/api/v1/asset-download/${postId}/${attachmentId}` : null,
    () => fetchSignedAssetDownloadUrl(postId, attachmentId),
    {
      throwOnError: false,
    }
  );
